import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/** Keeps the document `lang` attribute in sync with the active locale. */
const LanguageSync: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.resolvedLanguage?.split('-')[0] ?? 'en';
  }, [i18n.resolvedLanguage]);

  return null;
};

export default LanguageSync;
